// src/components/WZCreate.js
import React, { useContext } from 'react';
//import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import WZForm from './WZForm';

function WZCreate() {
  const navigate = useNavigate();
  const { user, token } = useContext(AuthContext);


  return (
    <div className="p-m-3">
      <WZForm />
    </div>
  );
}

export default WZCreate;
